import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

export const PictureContainer = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  background-position: center;
  background-size: cover;
  margin: ${({ center }) => (center ? 'auto' : 'initial')};
  border-radius: ${({ radius }) => (radius ? `${radius}` : 'none')};
  height: ${({ height }) => (height ? `${height}` : 'default')};
  width: ${({ width }) => (width ? `${width}` : 'default')};
  background-color: ${({ background }) => background};
`;

export const StyledPicture = styled(PictureContainer)`
  position: initial;
  left: 0;
  top: 0;
  transform: translateX(0);
  height: 100%;
`;

export const StyledGatsbyPicture = styled(GatsbyImage)`
  position: initial;
  overflow: hidden;
  display: flex;
  background-position: center;
  background-size: cover;
  margin: ${({ center }) => (center ? 'auto' : 'initial')};
  border-radius: ${({ radius }) => (radius ? `${radius}` : 'none')};
  width: ${({ width }) => (width ? `${width}` : 'default')};
  background-color: ${({ background }) => background};
  left: 0;
  top: 0;
  transform: translateX(0);
  height: 100%;
`;
